module.exports = __webpack_public_path__ + "static/media/laptop-one-heart.f837cdbc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/laptop-one-heart.png
 ** module id = 2084
 ** module chunks = 44
 **/